import MobilePaidsListItem, { MobilePaidsListItemPhone } from "./styles";

export { MobilePaidsListItemPhone };
export default MobilePaidsListItem;
